import { TLocalAuthContext } from '~/components/Auth';

export const getDateDifferenceInDays = (milliseconds1: number, milliseconds2: number) => {
  const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
  const differenceInDays = Math.round(Math.abs((milliseconds1 - milliseconds2) / oneDay));
  return differenceInDays;
};

const getDaysRangeString = (days: number) => {
  if (days > 6 * 30) {
    return '6_months';
  } else if (days > 3 * 30) {
    return '3_months';
  } else if (days > 30) {
    return '1_month';
  } else if (days > 7) {
    return '1_week';
  } else {
    return 'less_than_1_week';
  }
};

export const getUserLoginStatus = (auth: TLocalAuthContext): string => {
  if (!auth) return '';

  if (
    auth?.user?.currentState === 'ACTIVE' &&
    auth?.user?.prevState === 'ADDED' &&
    auth?.user?.stateUpdatedTime
  ) {
    // Converting stateUpdatedTime from seconds to milliseconds
    const prevTime = auth.user.stateUpdatedTime * 1000;
    const currentTime = Date.now();
    const differenceInDays = getDateDifferenceInDays(prevTime, currentTime);
    return getDaysRangeString(differenceInDays);
  }

  return '';
};
